namespace $.$$ {
	$mol_style_define($bog_bzrl_app_let, {
		display: 'flex',
		flex: {
			direction: 'column',
		},
		gap: '2rem',
	})
}
